/**
 * Notification Settings page for configuring push notification preferences
 */

import React from 'react';
import {
  IonPage,
  IonHeader,
  IonToolbar,
  IonTitle,
  IonButtons,
  IonBackButton,
  IonContent,
  IonCard,
  IonCardHeader,
  IonCardTitle,
  IonCardContent,
  IonToggle,
  IonLabel,
  IonItem,
  useIonViewWillLeave,
} from '@ionic/react';
import SnowballMenu from '@/modules/user/SnowballMenu';
import PageRefresher from '@/components/PageRefresher';
import { useUserSettings } from './UserSettingsContext';
import { pxToRem } from '@/modules/config/constants';

const NotificationSettings: React.FC = () => {
  const { getSettings, setAllowPushNotifications } = useUserSettings();
  const settings = getSettings();

  useIonViewWillLeave(() => {
    if (document.activeElement instanceof HTMLElement) {
      document.activeElement.blur();
    }
  });

  const handlePushNotificationsChange = (allow: boolean) => {
    setAllowPushNotifications(allow);
  };

  return (
    <IonPage>
      <IonHeader>
        <IonToolbar>
          <IonButtons slot="start">
            <IonBackButton defaultHref="/settings" />
          </IonButtons>
          <IonTitle>Notification Settings</IonTitle>
          <IonButtons slot="end">
            <SnowballMenu />
          </IonButtons>
        </IonToolbar>
      </IonHeader>
      <IonContent fullscreen>
        <PageRefresher />
        <div style={{ padding: '20px' }}>
          <IonCard>
            <IonCardHeader>
              <IonCardTitle>Notifications</IonCardTitle>
            </IonCardHeader>
            <IonCardContent>
              <IonItem>
                <IonLabel>
                  <h2>Allow push notifications</h2>
                  <p style={{ fontSize: pxToRem(14), color: '#666' }}>
                    Enable push notifications to receive updates and reminders.
                  </p>
                </IonLabel>
                <IonToggle
                  checked={settings.allowPushNotifications}
                  onIonChange={e =>
                    handlePushNotificationsChange(e.detail.checked)
                  }
                />
              </IonItem>
            </IonCardContent>
          </IonCard>
        </div>
      </IonContent>
    </IonPage>
  );
};

export default NotificationSettings;
